import React from "react";
import {
  LinearGauge,
  Scale,
  Tick,
  Label,
  RangeContainer,
  Range,
  ValueIndicator,
  SubvalueIndicator,
  // Export,
  // Title,
  // Font,
} from "devextreme-react/linear-gauge";

function LinearGaugeComponent(props) {
  return (
    <>
      <LinearGauge
        id="gauge"
        value={props.ind} 
        subvalues={props.ind}
        geometry={{ orientation: "vertical" }}

      >
        <Scale startValue={0} endValue={props.nivel * 1.5} tickInterval={props.nivel / 4}>
          <Tick color="#536878" />
          <Label indentFromTick={-3} />
        </Scale>
        <RangeContainer offset={10}>
          <Range startValue={0} endValue={props.nivel / 2} color="#92000A" />
          <Range startValue={props.nivel / 2} endValue={props.nivel} color="#E6E200" />
          <Range startValue={props.nivel} endValue={props.nivel * 1.5} color="#77DD77" />
        </RangeContainer>
        <ValueIndicator offset={20} />
        <SubvalueIndicator offset={-15} />
        {/* <Export enabled={props.export} /> */}
        {/* <Title text={props.title}>
          <Font size={28} />
        </Title> */}
      </LinearGauge>
    </>
  );
}
export default LinearGaugeComponent;
